<template>
  <div id="thanks">
    <Metadata
      :title="this.title"
    />
    <Top v-if="this.user" />
    <div class="thanks">Thank you</div>
      <template v-if="this.from === 'reset'">
        <div class="words">
          You should receive a password change notice at <strong>xyz@domain.com</strong> shortly.
        </div>
        <router-link class="return" to="/login">Return to Login</router-link>
      </template>
      <template v-if="this.from === 'update'">
        <div class="words">Your password has been successfully changed.</div>
        <router-link class="return" to="/advertisers">Return to Dashboard</router-link>
      </template>
      <template v-if="typeof this.from === 'undefined'">
        <div class="words">Please login.</div>
        <router-link class="return" to="/login">Login Now</router-link>
      </template>
    <Bottom />
  </div>
</template>

<script>

import Top from '../../components/nav/Top.vue';
import Bottom from '../../components/nav/Bottom.vue';

export default {
  name: 'thanks',
  components: {
    Top,
    Bottom,
  },
  props: {
    from: String,
  },
  data() {
    return {
      title: `reporting - thanks`,
      user: this.$store.state.user,
    };
  },
};
</script>

<style>
/* TODO: meryl - styling */
</style>
